// extracted by mini-css-extract-plugin
export default {"chartContainer":"ChartWrapper_chartContainer__Ju8EA","chartTitle":"ChartWrapper_chartTitle__tp9AP","chartSubtitle":"ChartWrapper_chartSubtitle__Yq0er"};